module.exports = __webpack_public_path__ + "static/img/swipe.f93a221d.png";